import apiClient from "../lib/api-client";

export interface UploadPrescriptionData {
  customerId?: string;
  patientName?: string;
  patientAge?: number;
  doctorName?: string;
  prescriptionDate?: string;
}

export const prescriptionService = {
  async uploadPrescription(file: File, data: UploadPrescriptionData) {
    const formData = new FormData();
    formData.append("file", file);

    if (data.customerId) formData.append("customerId", data.customerId);
    if (data.patientName) formData.append("patientName", data.patientName);
    if (data.patientAge)
      formData.append("patientAge", data.patientAge.toString());
    if (data.doctorName) formData.append("doctorName", data.doctorName);
    if (data.prescriptionDate)
      formData.append("prescriptionDate", data.prescriptionDate);

    const response = await apiClient.post("/prescriptions/upload", formData, {
      headers: { "Idempotency-Key": crypto.randomUUID() },
    });

    return response.data;
  },

  async getPrescriptionFileUrl(prescriptionId: string) {
    const response = await apiClient.get(
      `/prescriptions/${prescriptionId}/download`,
    );

    return response.data;
  },

  async getCustomerPrescriptions(customerId: string) {
    const response = await apiClient.get(
      `/prescriptions/customer/${customerId}`,
    );

    return response.data;
  },

  async getAllPrescriptions(params?: {
    customerId?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
  }) {
    const response = await apiClient.get("/prescriptions", { params });

    return response.data;
  },
};
